import { localesStore } from '~/mobx';

const showNAInsteadNull = (text: string) => (text === '' ? localesStore.t('not_available') : text);

export default showNAInsteadNull;
